import { useState, useEffect } from 'react';
import { Card, Stack, Typography } from '@mui/joy';
import { Warning } from '../icons';

export function ScheduleDataUpdateBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const checkTime = () => {
      const now = new Date();
      const utcHours = now.getUTCHours();
      const utcMinutes = now.getUTCMinutes();

      // Show banner between 00:00 and 00:30 UTC
      const shouldShow = utcHours === 0 && utcMinutes < 30;
      setIsVisible(shouldShow);
    };

    // Check immediately
    checkTime();

    // Check every minute
    const interval = setInterval(checkTime, 60000);

    return () => clearInterval(interval);
  }, []);

  if (!isVisible) return <></>;

  return (
    <Card
      variant="soft"
      color="warning"
      size="md"
      sx={{
        mx: 2,
        my: 1,
        borderRadius: 'sm',
      }}
    >
      <Stack direction="row" alignItems="flex-start" spacing={1.5}>
        <Warning fontSize="xl" color="warning" />
        <Stack direction="column" spacing={0.5} sx={{ flexGrow: 1 }}>
          <Typography level="title-md" color="warning">
            Scheduled Data Update
          </Typography>
          <Typography level="body-sm" color="warning">
            A data refresh is in progress between 00:00 and 00:30 (UTC). Please note that displayed data may not reflect
            the most recent updates until the refresh is complete.
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
}
